import { defineMessages } from 'react-intl';

export default defineMessages({
  dropdownTitle: {
    id: 'frontbucket.repository.pullRequest.diffCommentNavigator.dropdownTitle',
    description: 'Title for comment navigator dropdown button',
    defaultMessage: 'Comments ({numUnresolved} unresolved)',
  },
  unresolvedCommentsTitle: {
    id: 'frontbucket.repository.pullRequest.diffCommentNavigator.unresolvedComments.Title',
    description: 'Title for unresolved comments header',
    defaultMessage: 'Unresolved Comments ({numThreads})',
  },
  resolvedCommentsTitle: {
    id: 'frontbucket.repository.pullRequest.diffCommentNavigator.resolvedComments.Title',
    description: 'Title for resolved comments header',
    defaultMessage: 'Resolved Comments ({numThreads})',
  },
  commentDescription: {
    id: 'frontbucket.repository.pullRequest.diffCommentNavigator.commentDescription',
    description: 'Description for comments within previews',
    defaultMessage: '{date} on {filename}',
  },
  outdatedLabel: {
    id: 'frontbucket.repository.pullRequest.diffCommentNavigator.outdatedLabel',
    description: 'Label for outdated comments',
    defaultMessage: 'Outdated',
  },
  unresolvedCommentsEmpty: {
    id: 'frontbucket.repository.pullRequest.diffCommentNavigator.unresolvedComments.empty',
    description: 'Label for unresolved comment dropdown with 0 threads',
    defaultMessage: 'No unresolved comments',
  },
  resolvedCommentsEmpty: {
    id: 'frontbucket.repository.pullRequest.diffCommentNavigator.resolvedComments.empty',
    description: 'Label for resolved comment dropdown with 0 threads',
    defaultMessage: 'No resolved comments',
  },
  allCommentsEmpty: {
    id: 'frontbucket.repository.pullRequest.diffCommentNavigator.empty',
    description: 'Label for comment nav with 0 threads',
    defaultMessage: 'No comments',
  },
});
